import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseForm from 'components/atoms/base-form';
import BaseFormItem from 'components/atoms/base-form/item';
import BaseGrid from 'components/atoms/base-grid';
import { useFormik } from 'formik';
import ClinicInvoiceServiceTypeSelectBox from 'components/molecules/clinic-invoice-service-type-select-box';
import BaseTextArea from 'components/atoms/base-textarea';
import ClinicInvoiceBillingTypeSelectBox from 'components/molecules/clinic-invoice-billing-type-select-box';
import BaseInputNumber from 'components/atoms/base-input-number';
import BaseSwitch from 'components/atoms/base-switch';
import BaseInput from 'components/atoms/base-input';

import s from './styles.module.scss';
import { validationSchema } from './validation-schema';

import type { ClinicInvoice } from 'infrastructure/classes/clinic-invoice/clinic-invoice';

interface IProps {
  data: ClinicInvoice;
  onCancel: () => void;
  onSave: (rec: ClinicInvoice) => void;
}

const ClinicInvoiceEditForm: React.FC<IProps> = (props) => {
  const { t } = useTranslation();

  const { data, onCancel, onSave } = props;

  const formik = useFormik({
    initialValues: structuredClone(data),
    onSubmit: async (values) => {
      onSave(values);
    },
    validationSchema: validationSchema(),
    validateOnChange: false,
  });

  const { values } = formik;

  const statusLabel = values.status ? t('labels.active') : t('labels.inactive');

  return (
    <div>
      <BaseForm
        formik={formik}
        withControls
        onCancel={onCancel}
        onSave={formik.submitForm}
      >
        <BaseGrid columns={2}>
          <BaseFormItem name="serviceType" label={t('labels.serviceType')}>
            <ClinicInvoiceServiceTypeSelectBox />
          </BaseFormItem>
          <BaseFormItem name="billingType" label={t('labels.billingType')}>
            <ClinicInvoiceBillingTypeSelectBox />
          </BaseFormItem>
        </BaseGrid>
        <BaseFormItem name="name" label={t('labels.name')}>
          <BaseInput />
        </BaseFormItem>
        <BaseFormItem
          required
          name="description"
          label={t('labels.description')}
        >
          <BaseTextArea rows={2} maxRows={2} />
        </BaseFormItem>

        <BaseFormItem
          required={values.status}
          name="price"
          label={t('labels.productPrice')}
        >
          <BaseInputNumber prefix="$" />
        </BaseFormItem>

        <BaseFormItem name="status">
          <div className={s['status-wrapper']}>
            <div className={s.status}>
              {t('labels.status')}
              <BaseSwitch
                checked={values.status}
                label={statusLabel}
                onChange={(val) => formik.setFieldValue('status', val)}
              />
            </div>
          </div>
        </BaseFormItem>
      </BaseForm>
    </div>
  );
};

export default ClinicInvoiceEditForm;
